import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Dermatology = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my dermatology business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps dermatology businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for dermatology businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most dermatology businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my dermatology business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like dermatology. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Dermatology - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Dermatology CRM", url: "/industries/dermatology" }
  ];

  const industryData = {
    name: 'Dermatology Practice',
    title: 'Fill Your Schedule & Increase Cosmetic Procedure Revenue',
    subtitle: 'Automate appointment reminders, follow up on treatment plans, and grow your cosmetic dermatology services',
    icon: '✨',
    challenges: [
      'Cosmetic consultations don\'t convert',
      'Patients miss follow-up appointments',
      'Hard to upsell additional procedures',
      'Annual skin checks are forgotten',
      'Long wait times frustrate patients'
    ],
    solutions: [
      'Consultation to procedure automation',
      'Follow-up appointment scheduling',
      'Procedure upsell campaigns',
      'Annual skin check reminders',
      'Online booking reduces wait times'
    ],
    features: [
      'Patient CRM with skin condition tracking',
      'Before/after photo documentation',
      'Procedure package management',
      'Annual check reminders',
      'Treatment plan tracking',
      'Online consultation booking',
      'Product recommendation system',
      'Review automation'
    ],
    results: [
      '65% consultation conversion',
      '3x cosmetic procedure revenue',
      '85% annual check compliance',
      '£9.7K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Dermatology UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for dermatology businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for dermatology UK, dermatology business software, dermatology customer management, dermatology lead generation UK"
        url="/industries/dermatology"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Dermatology;